var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    fill: "none",
    viewBox: "0 0 26 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ADADAD",
    d: "M9.564 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM9.564 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM9.564 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM9.564 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM15.564 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM15.564 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM15.564 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM15.564 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.f2a6ed70.svg";
export { ForwardRef as ReactComponent };